const styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: '.25rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    marginBottom: '1.875rem !important',
    padding: '0 !important',
  },
  row: {
    margin: '0 !important',
    padding: '0 !important',
  },
  mapContainer: {
    padding: '0 !important',
  },
  details: {
    padding: '1.875rem !important',
  },
  header: {
    fontSize: '1.25rem !important',
    color: '#4a4a4a !important',
    fontWeight: '500 !important',
    marginBottom: '.5rem !important',
  },
  info: {
    color: '#999999 !important',
    fontSize: '.75rem !important',
  },
  address: {
    fontSize: '.875rem !important',
    marginBottom: '1.872rem !important',
  },
  value: {
    padding: '0 !important',
    color: '#4a4a4a !important',
  },
};

export default styles;
